const LOCATION_AWARENESS_ON = "on";

export function checkLocationAwareness(locationAwareness: string): boolean {
  return locationAwareness === LOCATION_AWARENESS_ON;
}
